import React from 'react';
import { useLanguage } from '../../Contexts/LanguageContext';
import './PurposePilot.scss';
import TaskList from '../TaskList/TaskList';
import Timeline from '../Timeline/Timeline';


const PurposePilot = () => {
  const { getLanguageData } = useLanguage();
const data = getLanguageData();
  
  const sectionTitle = data.purposeSection.heading;
  const sectionDescription= data.purposeSection.description;

  return (
    <>      
      <div className="section-spacing purpose-section">        
        <div className="row-container">
            <div className='purpose-desc-section'>
              <h2>{sectionTitle}</h2>
              {sectionDescription.map((paragraph, idx) => (
                <p key={idx} className="section-description">
                  {paragraph}
                </p>
              ))}
            </div>            
            <TaskList />          
        </div>
        <div className="row-container">            
            <Timeline />          
        </div>
      </div>
    </>
  );
};

export default PurposePilot;
